<template>
  <div class="index">
    <div style="margin-bottom: 10px">
      <el-breadcrumb slot="breadcrumb" class="breadcrumb-bg">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>添加文章</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="标题" >
                <el-input v-model="form.title"></el-input>
            </el-form-item>


            <el-form-item label="描述" >
                <el-input v-model="form.description"></el-input>
            </el-form-item>

            <el-form-item label="图片" >
                <el-input v-model="form.pic"></el-input>
            </el-form-item>
            <el-form-item label="跳转网址" >
                <el-input v-model="form.url"></el-input>
            </el-form-item>
            <el-form-item label="上传" >
                <el-upload

                        class="avatar-uploader"
                        name="file"

                        :action="upload_url"
                        list-type="picture-card"
                        :on-success="goodsSuccess"


                        :data="{ key: 'uploads' }"
                        :limit="limit"

                        ref="pic_show"
                >

                    <i  class="el-icon-plus avatar-uploader-icon"></i>

                </el-upload>


            </el-form-item>



            <el-form-item label="类型" prop="type">
                <el-select v-model="form.type" placeholder="类型">
                    <el-option label="文字" value="0"></el-option>
                    <el-option label="图文" value="1"></el-option>

                </el-select>
            </el-form-item>

            <el-form-item label="描述">

                    <quill-editor
                            ref="myQuillEditor"
                            v-model="form.content"


                    />
            </el-form-item>
            <el-form-item class="quill-editor-top" style="margin-top: 60px">
                <el-button @click="submitForm('form')" type="primary" >添加</el-button>
            </el-form-item>

        </el-form>
    </el-card>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import url from "../utils/urls";
export default {
  data() {
    return {
      upload_url: url.root + "/admin/upload/index",
        limit:1,
      form: {
        title:"",

        content :"",
        description:"",
        type:"",
        url:"",
        pic:"",


      },

      rules: {
          type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "blur",
          },

        ],
      },

    };
  },
  methods: {
    ...mapActions({
        getArticleIndexAction: "getArticleIndexAction",
        addArticleAction:"addArticleAction"
    }),
      //展示图片
      goodsSuccess(res, file) {
        console.log(res)

          file.url = file.response.upload_filename;
          this.form.pic=file.url

      },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          this.addArticleAction({
              title: this.form.title,
              url: this.form.url,
              content: this.form.content,

              pic: this.form.pic,
              description: this.form.description,
              type:this.form.type,



          });


        } else {

          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
      // this.getMenuIndexAction({ type:0})
  },
    computed: {
    //   ...mapState({dataIndex:"index.dataIndex"}),
    ...mapState({
      result: (state) => state.article.result,
    }),
  },
  watch: {
    result(val) {
      if (val.code == 301) {
        this.$message({
          message: "菜单添加成功",
          type: "success",
        });
      }
        if (val.code == 400) {
            this.$message({
                message: "菜单添加失败",
                type: "warning",
            });
        }
        if(val.code==200){
            this.cate_data=val.data

        }
        this.form.name=""
        this.form.state="1"
        this.form.pid="0"
        this.form.component=""
        this.form.icons=""
        this.form.path=""
        this.form.title=""
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.quill-editor {
    height: 400px;
}
</style>
